import React from "react";
import styled from "styled-components";
import CoachAvailabilityForm from "./CoachAvailabilityForm";
import { useTranslation } from "react-i18next";

const AvailabilitiesTab = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Title>{t("availabilityTab.title")}</Title>
      <CoachAvailabilityForm />
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  font-family: 'Poppins', sans-serif;
  margin-top: -30px;
`;

const Title = styled.h2`
  font-size: 35px;
  color: #6d9886;
  margin-bottom: 1.5rem;
`;

export default AvailabilitiesTab;
